module.exports = __webpack_public_path__ + "static/media/1006136.23884e3c.png";